import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import {compose, getContext} from 'recompose';

import {translate} from 'iss/strings';
import {JustRenderChildren, withContextFromProps} from 'iss/utils/context';
import { Accordion, AccordionSection, getAccordionContext } from 'iss/widgets/Accordion';
import {Button} from 'iss/widgets/Buttons';
import {Form, FormContext, ValidationErrorBox} from 'iss/widgets/Forms';

export const AccordionForm = class AccordionForm extends React.Component {
  state = {
    openedSection: 0
  };
  validators = {};
  render() {
    return <Accordion openedSection={this.state.openedSection} onOpenSection={this.openSection}>
      {React.Children.map(this.props.children, (child, index) => {
        return <AccordionFormSectionContext {...this.props}
          setValidator={(validator) => this.validators[index] = validator} onSubmit={this.onSubmit}>
          {child}
        </AccordionFormSectionContext>;
      })}
    </Accordion>;
  }
  onSubmit = () => {
    const {openedSection} = this.state;
    const isLastSection = openedSection == React.Children.count(this.props.children) - 1;
    if (isLastSection) {
      this.submitAccordionForm();
    } else {
      this.openSection(openedSection+1);
    }
  };
  submitAccordionForm = () => {
    const isInvalidSection = i => !this.validators[i]();
    const firstInvalidSection = R.find(isInvalidSection, R.keys(this.validators));

    if (firstInvalidSection !== undefined) {
      //firstInvalidSection is a string since its an object key
      this.openSection(parseInt(firstInvalidSection));
      return false;
    }
    this.props.onSubmit();
  };
  openSection = (i) => this.setState({openedSection: i});
};

const accordionFormContextTypes = {
  nextButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  values: PropTypes.object.isRequired,
  valueUpdater: PropTypes.func.isRequired,
  setValidator: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const AccordionFormSectionContext = withContextFromProps(
  accordionFormContextTypes
)(JustRenderChildren);
const getAccordionFormSectionContext = getContext(accordionFormContextTypes);

export const AccordionFormSection = getAccordionFormSectionContext(({children, values, valueUpdater, setValidator, onSubmit, ...props}) => {
  return <AccordionSection {...props}>
    <Form values={values} valueUpdater={valueUpdater} onSubmit={onSubmit}>
      {(values, formApi) => {
        setValidator(formApi.validate);
        return <React.Fragment>
          {children}
          <NextSectionButton/>
        </React.Fragment>;
      }}
    </Form>
  </AccordionSection>;
});

export const PlainAccordionFormSection = getAccordionFormSectionContext(({values, valueUpdater, children, setValidator, validate, onSubmit, ...props}) => {
  //Note: we should always update everything when the
  //last section is open because proper validation may depend on it
  return <AccordionSection {...props} shouldUpdate={({openedSection, lastSection}) => openedSection === lastSection}>
    <FormContext values={values} valueUpdater={valueUpdater} onSubmit={onSubmit}>
      {(values, formApi) => {
        setValidator(formApi.validate);
        return <React.Fragment>
          {children}
          <form onSubmit={formApi.submit} className="submitSection" >
            <NextSectionButton className="submitSection"/>
            {validate ? <ValidationErrorBox validate={validate} /> : null}
          </form>
        </React.Fragment>;
      }}
    </FormContext>
  </AccordionSection>;
});

const NextSectionButton = compose(
  getAccordionContext,
  getContext(accordionFormContextTypes),
)(function NextButton({isLastSection, nextButtonText, submitButtonText, id}) {
  const nextSectionStr = R.defaultTo(translate('common.nextSection'), nextButtonText);
  const submitSectionStr = R.defaultTo(translate('common.save'), submitButtonText);

  return <Button type="submit" buttonLook={isLastSection ? 'primary' : 'default'} id={id}>
    {isLastSection ? submitSectionStr : nextSectionStr}
  </Button>;
});



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/AccordionForm.jsx